
export default function PartnershipHero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/1d77b4ed64d70b6134a8cfec1bdc35f5.jpg')`
      }}
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-full">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Partner with OED
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed">
            Join the future of luxury outdoor hospitality. Become an owner-partner in OED Glamping Retreat Developments and build wealth through sustainable tourism investments.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#partnership-options"
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Explore Partnership Options
            </a>
            <a
              href="#partnership-application"
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap border border-white/30"
            >
              Apply for Partnership
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
